// Match ID as abc-defg-hij
export function isMeetingId(path: string): boolean {
  return /^[a-z]{3}-[a-z]{4}-[a-z]{3}$/.test(path);
}

// Match ID as abcdefghij
function isSquishedMeetingId(id: string): boolean {
  return /^[a-z]{10}$/.test(id);
}

// Match squished ID as abcdefghij -> abc-defg-hij
function normalizeSquishedMeetingId(id: string): string {
  return `${id.slice(0, 3)}-${id.slice(3, 7)}-${id.slice(7, 10)}`;
}

export function parseMeetingUrl(meetingUrl: string): string | null {
  // Direct meeting ID
  if (isMeetingId(meetingUrl)) {
    return meetingUrl;
  }

  // Squished meeting ID
  if (isSquishedMeetingId(meetingUrl)) {
    return normalizeSquishedMeetingId(meetingUrl);
  }

  // Try to extract meeting ID from any URL
  try {
    const url = new URL(meetingUrl);
    // Get the last part of the path
    const pathParts = url.pathname.split('/').filter(Boolean);
    const id = pathParts[pathParts.length - 1];
    if (isMeetingId(id)) {
      return id;
    }
    if (isSquishedMeetingId(id)) {
      return normalizeSquishedMeetingId(id);
    }
  } catch (e) {
    // Not a valid URL, ignore
  }

  return null;
}
